import React from 'react';
import { Link } from 'gatsby';

function JustLanded() {
  return (
    <article className="px-4 sm:px-6 lg:px-8">
      <div className="py-24 text-center text-white bg-light-pink">
        <div className="grid w-full max-w-2xl mx-auto sm:grid-cols-2">
          <h2 className="text-3xl font-bold tracking-wider uppercase ">
            Just landed
          </h2>
          <div className="text-xl">
            <Link
              to="/collections/shorts/"
              className="hover:underline focus:underline"
            >
              <p>Shop our newest shorts</p>
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}

export { JustLanded };
